<app-menu>
  <div class="desktop">
    <app-voltar class="back" />
    <div class="header">
      <app-titulo text="Validação do Projeto"></app-titulo>
      <h1>{{ form.NmProjeto }}</h1>
    </div>
    <div class="body">
      <div class="project-infos">
        <div class="pdf">
          <pdf-viewer
            [src]="form.TxImagemProjeto"
            [rotation]="0"
            [original-size]="false"
            [show-all]="true"
            [fit-to-page]="false"
            [zoom]="1"
            [zoom-scale]="'page-width'"
            [stick-to-page]="false"
            [render-text]="true"
            [external-link-target]="'blank'"
            [autoresize]="true"
            [show-borders]="false"
          ></pdf-viewer>
        </div>
        <div class="disciplinas">
          <app-titulo text="Disciplinas do Projeto"></app-titulo>
          <div
            class="disciplina-info"
            *ngFor="let disciplina of form.Disciplinas"
          >
            <h1>
              {{ disciplina.NmDisciplina }}
            </h1>
            <div class="pdf">
              <pdf-viewer
                [src]="disciplina.TxImagemDisciplina"
                [rotation]="0"
                [original-size]="false"
                [show-all]="true"
                [fit-to-page]="false"
                [zoom]="1"
                [zoom-scale]="'page-width'"
                [stick-to-page]="false"
                [render-text]="true"
                [external-link-target]="'blank'"
                [autoresize]="true"
                [show-borders]="false"
              ></pdf-viewer>
            </div>
          </div>
        </div>
      </div>
      <div class="buttons">
        <button class="btn-red" (click)="reprovarProjeto()">
          Reprovar Projeto
        </button>
        <button class="btn-green" (click)="aprovarProjeto()">
          Aprovar Projeto
        </button>
      </div>
    </div>
  </div>
</app-menu>

<app-loader *ngIf="loader" />
